/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_BreedInputs */

const en_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breed`)
};

const es_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raza`)
};

const fr_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race`)
};

const de_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasse`)
};

const ja_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品種`)
};

const zh_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品种`)
};

const ar_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السلالة`)
};

const id_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ras`)
};

const it_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razza`)
};

const ru_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Порода`)
};

const pt_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raça`)
};

const ko_field_breed = /** @type {(inputs: Field_BreedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`품종`)
};

/**
* | output |
* | --- |
* | "Breed" |
*
* @param {Field_BreedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_breed = /** @type {((inputs?: Field_BreedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_BreedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_breed(inputs)
	if (locale === "es") return es_field_breed(inputs)
	if (locale === "fr") return fr_field_breed(inputs)
	if (locale === "de") return de_field_breed(inputs)
	if (locale === "ja") return ja_field_breed(inputs)
	if (locale === "zh") return zh_field_breed(inputs)
	if (locale === "ar") return ar_field_breed(inputs)
	if (locale === "id") return id_field_breed(inputs)
	if (locale === "it") return it_field_breed(inputs)
	if (locale === "ru") return ru_field_breed(inputs)
	if (locale === "pt") return pt_field_breed(inputs)
	return ko_field_breed(inputs)
});